import { LoadingButton } from '@mui/lab';
import { Box, Card, MenuItem, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { cuponesTipoValue } from '../../../../../constants/cupones/tipoCupones';
import PaqueteriaAvatar from '../../../paquetes/general/PaqueteriaAvatar';
import useAuthUsers from '../../../../../hooks/useAuthUsers';

function DescuentoForm({ dataItem, dataUser, descuentosDoc }) {
  const [tipoState, setTipoState] = useState('porcentaje');
  const { currentUser } = useAuthUsers();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors, isSubmitting }
  } = useForm();

  const onSubmit = async (dataForm) => {
    const obj = {
      status: 'active',
      descuentoValue: Number(dataForm.value),
      tipoValue: tipoState,
      paqueteriaName: dataItem.name,
      id: dataItem.id
    };
    console.log(obj);

    const finded = descuentosDoc.listPaqDesc.find((item) => item.id === obj.id);

    if (finded) {
      const filtered = descuentosDoc.listPaqDesc.filter((item) => item.id !== obj.id);
      const newArr = [...filtered, obj];
      await firestore.collection('desc_porPaqueteria').doc(descuentosDoc.id).update({ listPaqDesc: newArr });
    } else {
      const newArr = [...descuentosDoc.listPaqDesc, obj];
      await firestore.collection('desc_porPaqueteria').doc(descuentosDoc.id).update({ listPaqDesc: newArr });
    }
  };

  const paqueteriaData = descuentosDoc.listPaqDesc.find((item) => item.id === dataItem.id);
  // console.log(paqueteriaData);

  useEffect(() => {
    if (paqueteriaData) {
      setValue('value', paqueteriaData.descuentoValue);
      setTipoState(paqueteriaData.tipoValue);
    }
  }, [paqueteriaData, setValue]);

  const filteredArr =
    currentUser.role === 'almighty' ? cuponesTipoValue : cuponesTipoValue.filter((item) => item.value === 'porcentaje');

  return (
    <Card sx={{ display: 'flex', gap: '15px', alignItems: 'center', padding: '10px', marginBottom: '10px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '150px' }}>
        <PaqueteriaAvatar size="small" rate_provider={dataItem.name} />
        <Typography variant="subtitle2">{dataItem.name}</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }} component="form" onSubmit={handleSubmit(onSubmit)}>
        <TextField
          id="outlined-select-currency"
          select
          label="Tipo"
          size="small"
          // defaultValue={cuponesTipo[0].value}
          value={tipoState}
          sx={{ width: '150px' }}
          onChange={(e) => setTipoState(e.target.value)}
          // helperText="Elija el tipo"
        >
          {filteredArr.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          type="number"
          error={!!errors.value}
          {...register('value', { required: true })}
          size="small"
          label="Valor"
          inputProps={currentUser.role === 'almighty' ? {} : { max: tipoState === 'numero' ? 50 : 10 }}
        />
        <LoadingButton loading={isSubmitting} type="submit" variant="contained">
          Guardar
        </LoadingButton>
      </Box>
    </Card>
  );
}

export default DescuentoForm;
